import React from "react";
import RouterApp from "../navigations/Router";
import Auth from "./Auth";
import {useApp} from "../contexts/App";

export default function Main(props: any) {
    const {user} = useApp();

    return !!user ? (
        <div style={{backgroundColor: '#fbfbfb'}} className="d-flex flex-column flex-root">
            <div className="page d-flex flex-row flex-column-fluid">
                <RouterApp/>
            </div>
        </div>
    ) : (
        <Auth/>
    )
}
